import { onViewLoad } from "./on_view_load.js";
import { initStickySubnavHeader } from "./sticky_subnav_header.js";

const VIEWS = [
  "recipes#edit",
  "recipes#show",
  "recipes#cost",
  "recipes#history",
  "recipes#recipe_card",
  "ingredient_metas#index_for_recipe",
  "ingredient_allergens#index_for_recipe",
];

onViewLoad(VIEWS, () => {
  initStickySubnavHeader();
});
